
import React, { useEffect,  useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {  getContentsClientByFolder } from "../../store/actions/CreateCourse/CourseApi";
import { AudioWaveform, Blocks, ChevronDown, ChevronUp, Fan, Folder, Info, Video } from "lucide-react";
import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import PlayerPageCardLessonCard from "./PlayerPageCardLessonCard";

const PlayerPageCardFolderContents =({courseId,playerCard1Object,setCurrentItem,folderItem,progress=20})=>{
          const [itemArr, setItemArr] = useState([]);
               const [counts, setCounts] = useState({});
               
               const [openFolder, setOpenFolder] = useState(true);
               
                       const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
                
      const [sort, setSort] = useState("ASC");
               const [pageNo, setPageNo] = useState(1);
               const [limit, setLimit] = useState(10);
             const [dropDownVal, setDropDownVal] = useState("Active");
                const [startDate, setStartDate] = useState(null);
          
            const [endDate, setEndDate] = useState(null);
      const [advancedFilters , setAdvancedFilters] =useState(true)
         const [toggleStatePaid , setToggleStatePaid] =useState(null)
         const [toggleStateLifetime , setToggleStateLifetime] =useState(null)
       
       const dispatch = useDispatch();
                const user = useSelector((state)=>state?.user?.user);
                     
                const [snackbarVisible, setSnackbarVisible] = useState(false);
                                 const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                                 const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                           
                                  
                              const showSnackbar = () => {
                                setSnackbarVisible(true);
                              };
                             
                              const hideSnackbar = () => {
                                setSnackbarVisible(false);
                              };
                        
                        
                                   
                                   
                                
                               const [animate, setAnimate] = useState(false);
                 
                  const [loader , setLoader] =useState({status:true});
         
             
                    const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
                    const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
                   );
                   
                       const userData =useSelector((state)=>state?.user?.user);
                      const AppToken = useSelector((state)=>state?.user?.user?.appToken);
                      const appId = useSelector((state)=>state?.user?.user?.appId);
                    
                              
           
         const fireGetContentsClientByFolder=()=>{
                setItemArr([])
                 
             
               setItemArrLoading([{},{},{},{}])
               setLoader({status:true});
                     const apiData = dispatch(getContentsClientByFolder({userEmail:userEmail?userEmail:"",
            currentToken:currentToken?currentToken:"",productType:"course", courseId:courseId,postParent:folderItem?.ID}));
                     /* get response as Promise   */
                     apiData.then(response => {
                     console.log(response)
               
                       if(response?.contents){
                       setItemArr(response?.contents);
               setItemArrLoading([])
                       setResponseMessage(response?.message);
                       setSnackbarColor("rgba(144, 202, 249,1)");
                     
                   setLoader({status:false});
                   
                   // setSnackbarVisible(true);
                   setTimeout(()=>{
                     
                     setSnackbarVisible(false);
                   },1000)
                   
                         
                       
                      if(response?.logout){
                      
                       setResponseMessage("You are Logged Out!!!");
                         
                       setSnackbarColor("#958FDA");
                     
                       
                        
                   setLoader({status:false});
                   
                   setSnackbarVisible(true);
                   setTimeout(()=>{
                     
                     setSnackbarVisible(false);
                    
                      
                   },3000)
                       setTimeout(()=>{
                         dispatch({type:"LOGOUT"});
                   
                       },3000)
                       
                     }
                   
                       }else{
                         setResponseMessage("Something Went Wrong...");
                         
                         setSnackbarColor("#958FDA");
                       
                          
                     setLoader({status:false});
                     
                     setSnackbarVisible(true);
                     setTimeout(()=>{
                       
                       setSnackbarVisible(false);
                      
                        
                     },3000)    }
                   
                     }).catch(error => {
                    
                       //popup of error Info
                       setResponseMessage("Something Went Wrong...");
                         
                       setSnackbarColor("#958FDA");
                    
                       
                        
                   setLoader({status:false});
                   
                   setSnackbarVisible(true);
                   setTimeout(()=>{
                     
                     setSnackbarVisible(false);
                    
                      
                   },3000)
                      
                     });
                }
       
     
     useEffect(()=>{fireGetContentsClientByFolder()},[])
       const flattenedData = itemArr!=[]?Object.values(itemArr):'';
     
              const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
      
    return(<> <div className="sidebarCardChapter" style={{background:`${playerCard1Object?.folder?.bgColor?.color}`,
border:` ${playerCard1Object?.folder?.border?.borderWidth?.value+playerCard1Object?.folder?.border?.borderWidth?.resolution} ${playerCard1Object?.folder?.border?.borderType}  ${playerCard1Object?.folder?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.folder?.borderRadius?.topLeft?.value}${playerCard1Object?.folder?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.folder?.borderRadius?.topRight?.value}${playerCard1Object?.folder?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.folder?.borderRadius?.bottomLeft?.value}${playerCard1Object?.folder?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.folder?.borderRadius?.bottomRight?.value}${playerCard1Object?.folder?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px",padding:"4px"}}>
    <div className="sidebarCardSectionInner" ><div>
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <Folder size={26} color={playerCard1Object?.folder?.textColor?.color} />
    <div className="player-cardTitleFont" style={{fontSize:"14px",fontWeight:"800",margin:"0px",color:`${playerCard1Object?.folder?.textColor?.color}`}}>{playerCard1Object?.folder?.title}</div>
    </div><div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px",margin:"7px"}}>
    
    {folderItem?.counts?.folders?<span className="player-cardTagsFont" style={{fontSize:"10px",color:`${playerCard1Object?.folder?.textColor?.color}`}}>{folderItem?.counts?.folders} Folders</span>:""}
    {folderItem?.counts?.videos?<span className="player-cardTagsFont" style={{fontSize:"10px",color:`${playerCard1Object?.folder?.textColor?.color}`}}>{folderItem?.counts?.videos} Videos</span>:""}
    {folderItem?.counts?.quizzes?<span className="player-cardTagsFont" style={{fontSize:"10px",color:`${playerCard1Object?.folder?.textColor?.color}`}}>{folderItem?.counts?.quizzes} Quizzes</span>:""}
    </div> 
    </div>
   {openFolder? <div onClick={()=>{setOpenFolder(false)}} style={{background:`${playerCard1Object?.folder?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} ><ChevronUp size={22}  color={playerCard1Object?.folder?.iconColor?.color}/></div> 
:<div onClick={()=>{setOpenFolder(true)}} style={{background:`${playerCard1Object?.folder?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} ><ChevronDown size={22}  color={playerCard1Object?.folder?.iconColor?.color}/></div> 
    }

</div>
   
{
  // lesson Card
}
{openFolder?flattenedDataLoading?.length==0?flattenedData?.length?
flattenedData?.map((item,index)=>(<div key={index}>
 
 <PlayerPageCardLessonCard setCurrentItem={(v)=>{setCurrentItem(v)}} playerCard1Object={playerCard1Object} contentItem={item} />
 
   
   
   
   </div>)):"":"":""}


   </div> 
    </>)
}
export default PlayerPageCardFolderContents